import { Theme } from '@mui/material/styles'
import { CheckboxProps } from '@mui/material/Checkbox'
//
import { CheckboxIcon, CheckboxCheckedIcon, CheckboxIndeterminateIcon } from './CustomIcons'
import { hoverRing } from '../interaction'

// ----------------------------------------------------------------------

export default function Checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckboxIcon />,
        checkedIcon: <CheckboxCheckedIcon />,
        indeterminateIcon: <CheckboxIndeterminateIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: CheckboxProps }) => ({
          padding: theme.spacing(1),
          // MUI computes a selection control's hover from its colour prop, and both
          // Checkbox and Radio default to `color="primary"` — which is navy. Every
          // checkbox in the app was hovering cool blue inside warm-grey chrome.
          //
          // The ring is a fixed size rather than the padding's, so a call site that
          // shrinks the control to fit a row does not shrink its hover with it.
          ...hoverRing(theme),
          // On-state is navy, the kit's selected colour, never amber: amber is 1.54:1
          // on white and fails the 3:1 control-boundary rule — amber means action.
          // :not(.Mui-disabled) keeps MUI's disabled styling winning, so a
          // disabled checked control still reads as disabled.
          '&.Mui-checked:not(.Mui-disabled), &.MuiCheckbox-indeterminate:not(.Mui-disabled)': {
            color: theme.palette.primary.main,
          },
          // MUI's default is action.disabled, which this palette sets at 80 % grey: a disabled
          // box read darker than an enabled one, e.g. the import preview's locked rows
          '&.Mui-disabled': {
            color: theme.palette.text.disabled,
          },
          ...(ownerState.size === 'small' && {
            '& svg': { width: 20, height: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { width: 24, height: 24 },
          }),
        }),
      },
    },
  }
}
